/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Increase dropdown tolerance - delay before menu hides when mouse leaves (250ms)
  // Mega menu: align dropdown content with parent nav label via --mega-inline-start
  document.addEventListener('DOMContentLoaded', function() {
    var HoverDisclosure = customElements.get('hover-disclosure');
    if (!HoverDisclosure) return;
    var proto = HoverDisclosure.prototype;
    var nativeHide = proto.hideDisclosure;
    var HIDE_DELAY = 250;
    proto.hideDisclosure = function() {
      var self = this;
      if (self._hideTimeout) clearTimeout(self._hideTimeout);
      self._hideTimeout = setTimeout(function() {
        self._hideTimeout = null;
        if (self.disclosure && (self.grandparent || self.classList.contains('parent'))) {
          self.disclosure.style.removeProperty('--mega-inline-start');
          self.disclosure.style.removeProperty('--mega-shift-x');
        }
        nativeHide.call(self);
      }, HIDE_DELAY);
    };
    var originalShow = proto.showDisclosure;
    proto.showDisclosure = function(e) {
      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
      }
      originalShow.call(this, e);
      if (this.wrapper && this.classList.contains('parent')) {
        this.wrapper.classList.add('meganav--visible');
      }
      if (this.disclosure && this.link && (this.grandparent || this.classList.contains('parent'))) {
        setMegaMenuAlignVars(this);
      }
    };

    function setMegaMenuAlignVars(host) {
      var dd = host.disclosure;
      var link = host.querySelector('[data-top-link]');
      if (!dd || !link) return;
      var navtext = link.querySelector('.navtext');
      var itemRect = host.getBoundingClientRect();
      dd.style.setProperty('--mega-shift-x', itemRect.left + 'px');
      var alignRect = (navtext || link).getBoundingClientRect();
      dd.style.setProperty('--mega-inline-start', alignRect.left + 'px');
    }

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        document
          .querySelectorAll('hover-disclosure.grandparent.is-visible, hover-disclosure.parent.is-visible')
          .forEach(function(el) {
            setMegaMenuAlignVars(el);
          });
      }, 100);
    });

    var megaScrollQueued = false;
    window.addEventListener(
      'scroll',
      function() {
        if (megaScrollQueued) return;
        megaScrollQueued = true;
        requestAnimationFrame(function() {
          megaScrollQueued = false;
          document
            .querySelectorAll('hover-disclosure.grandparent.is-visible, hover-disclosure.parent.is-visible')
            .forEach(setMegaMenuAlignVars);
        });
      },
      { passive: true }
    );
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* Training product tabs: flatten nested panels + inject FAQ when page HTML is stale */
(function () {
  const TRAINING_PATHS = [
    '/products/facial-training',
    '/products/one-day-holistic-facial-training-gold-coast-melbourne',
  ];

  const isTrainingProductPage = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (TRAINING_PATHS.some((p) => path === p || path.endsWith(p))) return true;
    if (document.querySelector('tabs-component.product-tabs')) {
      const type = window.meta?.product?.type || '';
      if (/training|workshop/i.test(type)) return true;
    }
    return false;
  };

  const flattenProductTabs = (tabs) => {
    tabs.querySelectorAll('.tab-content').forEach((panel) => {
      if (panel.parentElement !== tabs) tabs.appendChild(panel);
    });
  };

  const faqItems = [
    { q: 'What is facial lymphatic drainage training?', a: '<p>Facial lymphatic drainage training teaches practitioners how to perform facial lymphatic drainage techniques that support the body\'s natural lymphatic pathways, encourage fluid movement, reduce the appearance of puffiness, and relaxation.</p><p>At Her Solis, lymphatic drainage is taught as part of a broader holistic treatment philosophy. Students learn not only the practical techniques, but also the anatomy, tissue behaviour, facial tension patterns, nervous system connection, and natural skincare principles that influence the skin and face over time.</p><p>The training combines facial lymphatic drainage, facial sculpting, intentional touch, and holistic practitioner awareness to create treatments that are both results-focused and deeply restorative.</p>' },
    { q: 'Is this training based on the Vodder Method?', a: '<p>The Her Solis Method is influenced by the foundational principles of the Vodder Method of Manual Lymphatic Drainage (MLD), one of the most recognised lymphatic drainage approaches worldwide.</p><p>Students learn key lymphatic principles including working directionally, preparing drainage pathways, using light pressure, and following the body\'s natural lymphatic flow.</p><p>The training also incorporates facial sculpting, TMJ release, fascial awareness, nervous system regulation, and holistic facial techniques that extend beyond traditional Vodder training.</p>' },
    { q: 'What will I learn during the training?', a: '<p>Students learn facial lymphatic drainage, facial sculpting techniques, TMJ awareness, facial anatomy, fascia, treatment flow, consultation skills, natural skincare principles, contraindications, and the practical application of the Her Solis Method.</p><p>The training combines theory and hands-on practice, helping practitioners develop confidence in both understanding the face and delivering effective treatments.</p>' },
    { q: 'Is certification included?', a: '<p>Yes. Students receive a Certificate of Completion upon successfully completing the training. The certificate recognises training in the Her Solis Method and confirms successful completion of the course.</p>' },
    { q: 'Can beginners attend?', a: '<p>Yes. The training has been designed to accommodate both beginners and experienced practitioners.</p><p>All anatomy, lymphatic concepts, treatment principles, and practical techniques are taught step-by-step, making the course suitable for those new to facial therapies while still providing valuable knowledge for experienced therapists.</p>' },
    { q: 'Is the training accredited?', a: '<p>The Her Solis training is a professional skills-based training program designed for continuing education and practitioner development. Students are responsible for ensuring the training meets any requirements set by their insurance provider, employer, or professional association.</p><p>If you are unsure, we recommend contacting your insurer prior to enrolment.</p>' },
    { q: 'How quickly can I offer treatments after training?', a: '<p>Most students feel confident incorporating elements of the treatment into their services immediately following training.</p><p>Confidence and technique naturally develop with practice, which is why the course includes practical training, treatment protocols, and ongoing support to help practitioners begin applying their skills as soon as possible.</p>' },
    { q: 'Who is this training suitable for?', a: '<p>This training is suitable for:</p><ul><li>Beauty Therapists</li><li>Dermal Therapists</li><li>Skin Therapists</li><li>Massage Therapists</li><li>Myotherapists</li><li>Physiotherapists</li><li>Osteopaths</li><li>Nurses</li><li>Holistic Practitioners</li><li>Wellness Professionals</li></ul><p>If you are unsure whether the training is suitable for your background, please contact us before booking.</p>' },
    { q: 'What makes the Her Solis Method different?', a: '<p>The Her Solis Method combines facial lymphatic drainage, facial sculpting, TMJ awareness, fascia, nervous system regulation, natural skincare principles, and intentional touch within one holistic treatment approach.</p><p>Rather than focusing solely on aesthetics, the method views the face as part of a larger interconnected system. Students learn to assess and support the skin, tissues, posture, tension patterns, and overall client wellbeing.</p><p>At its foundation, the Her Solis Method is guided by intentional care. Practitioners learn to support the body\'s natural processes while delivering treatments that are personalised, professional, and thoughtfully structured.</p>' },
  ];

  const buildFaqHtml = () => {
    const rows = faqItems.map((item) => `
      <details class="accordion" data-collapsible>
        <summary class="accordion__title font-heading" data-collapsible-trigger>
          ${item.q}
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </summary>
        <div class="accordion__body rte" data-collapsible-body>
          <div class="accordion__content" data-collapsible-content>${item.a}</div>
        </div>
      </details>`).join('');
    return `<div class="facial-training-faq"><collapsible-elements single="true">${rows}</collapsible-elements></div>`;
  };

  const ensureFaqTab = (tabs) => {
    const links = [...tabs.querySelectorAll('.tab-link')];
    const faqLink = links.find((link) => link.textContent.trim() === 'FAQ');
    const hasFaqPanel = Boolean(tabs.querySelector('.facial-training-faq'));
    if (faqLink && hasFaqPanel) return;

    const tabIndex = faqLink ? parseInt(faqLink.dataset.tab, 10) : links.length;
    const list = tabs.querySelector('.tabs.product-tabs-title');
    if (!list || Number.isNaN(tabIndex)) return;

    let activeFaqLink = faqLink;
    if (!faqLink) {
      activeFaqLink = document.createElement('li');
      activeFaqLink.className = `tab-link tab-link-${tabIndex}`;
      activeFaqLink.dataset.tab = String(tabIndex);
      activeFaqLink.tabIndex = 0;
      activeFaqLink.innerHTML = '<span>FAQ</span>';
      list.appendChild(activeFaqLink);
    }

    if (!tabs.querySelector(`.tab-content-${tabIndex}`)) {
      const panel = document.createElement('div');
      panel.className = `tab-content tab-content-${tabIndex} rte`;
      panel.innerHTML = buildFaqHtml();
      tabs.appendChild(panel);
    }

    if (!activeFaqLink.dataset.faqBound) {
      activeFaqLink.dataset.faqBound = 'true';
      activeFaqLink.addEventListener('click', () => {
        const panel = tabs.querySelector(`.tab-content-${tabIndex}`);
        if (!panel) return;
        tabs.querySelectorAll('.tab-link.current').forEach((el) => el.classList.remove('current'));
        tabs.querySelectorAll('.tab-content.current').forEach((el) => el.classList.remove('current'));
        activeFaqLink.classList.add('current');
        panel.classList.add('current');
      });
    }
  };

  const init = () => {
    if (!isTrainingProductPage()) return;
    document.querySelectorAll('tabs-component.product-tabs').forEach((tabs) => {
      flattenProductTabs(tabs);
      ensureFaqTab(tabs);
      flattenProductTabs(tabs);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
